import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons';
import CloseButton from './CloseButton';

const px = (value) => `${value}px`;

function Guide({ book = {} }) {
  const dispatch = useDispatch();
  const {
    guide,
    isOpen,
    markers,
  } = useSelector(store => store.guide);

  useEffect(() => {
    dispatch({ type: 'LOAD_GUIDEBOOK', guidebook: book });
  }, []);

  return (
    <div className="guide-wrap" data-open={isOpen}>
      <CloseButton side="t" />
      {markers.map((marker) => (
        <div
          key={marker.i}
          className="guide-marker border border-white border-lg rounded text-white"
          data-open={isOpen}
          style={{
            width: px(marker.width),
            height: px(marker.height),
            left: px(marker.left),
            top: px(marker.top),
          }}
        >
          <div
            className="guide-icon rounded d-flex justify-content-center align-items-center"
          >
            <FontAwesomeIcon icon={faQuestionCircle} size="2x" className="guide-pulse" />
          </div>
          <div
            className="guide-text text-white font-weight-bold lead p-3"
            data-side={marker.side}
          >
            {guide[marker.i]}
          </div>
        </div>
      ))}
      <div className="guide-bg" data-open={isOpen} />
    </div>
  );
}

export default Guide;
